<template>
  <van-popup v-model="show" round position="bottom" closeable @close="handleClose">
    <div class="header">
      <span>{{title}}</span>
    </div>
    <slot name="content"></slot>
    <div style="margin: 16px;" v-if="showConfirmBtn">
      <slot v-if ="$slots['footer']" name="footer"></slot>
      <van-button v-else round block type="info" @click="handleSubmit">确认</van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'DownDrawer',
  props: {
    title: {
      type: String,
      required: false,
      default: '标题'
    },
    showConfirmBtn: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    handleClose () {
      this.show = false
      this.$emit('close', {})
    },
    handleSubmit () {
      this.$emit('confirm', {})
    }
  }
}
</script>

<style lang="less" scoped>
  .header {
    font-weight: 500;
    font-size: 32px;
    line-height: 96px;
    text-align: center;
  }
</style>
